import { render, staticRenderFns } from "./ImSelect.vue?vue&type=template&id=613cc720"
import script from "./ImSelect.vue?vue&type=script&lang=js"
export * from "./ImSelect.vue?vue&type=script&lang=js"
import style0 from "./ImSelect.vue?vue&type=style&index=0&id=613cc720&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports